import {ENGINE_URL} from '../../config'

const apiUrl = ENGINE_URL;

const getOrders = (departamentId, setOrders) => {
        fetch(`${apiUrl}/server/public/`, {
        method: 'POST',
        headers: {
            "Content-Type" : "application/json",
        },
        body: JSON.stringify({ 
          kitchen: 'getOrders',
          data: departamentId
        }),
      })
      .then((response) => response.json())
      .then((data) => {
        setOrders(data);
      })
      .catch((error) => console.error(error))
};

const updateOrders = (orders, id, pid) => {
  return Object.entries(orders).reduce((acc, [orderId, order]) => {
    const ordersCount = Object.values(order).filter(value => typeof value === "object" && value !== null).length;

    if (orderId === id && ordersCount === 1) {
      delete acc[orderId];
    } else {
      const filteredOrders = Object.entries(order).reduce((innerAcc, [dishId, dish]) => {
        if (dishId !== pid) {
          innerAcc[dishId] = dish;
        }
        return innerAcc;
      }, {});
      acc[orderId] = filteredOrders;
    }

    return acc;
  }, {})
};
  
const SuccessOrder = (orders, setOrders, value) => {
    fetch(`${apiUrl}/server/public/`, {
      method: "POST",
      headers: {
        "Content-Type" : "application/json",
      },
      body: JSON.stringify({ 
        kitchen: "successOrder",
        data: { 
          id: value[0],
          pid: value[1]
        }
      }),
    })
    .then((response) => response.json())
    .then((data) => {
      setOrders(updateOrders(orders, value[0], value[1]))
    })
    .catch((error) => console.error(error));
};

const cancelOrder = (orders, setOrders, value) =>
{
    fetch(`${apiUrl}/server/public/`,{
        method: 'post',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            kitchen: "cancelOrder",
            data: {
                reasonId: value[0],
                orderId: value[1],
                dishId: value[2],
            }
        })
    })
    .then((response) => {
        if (!response.ok)
        {
            return false;
        }
        return response.json();
    })
    .then((data) => {
        setOrders(updateOrders(orders, value[1], value[2]))
    })
    .catch((error) => console.error(error))
}

const updateQuantity = (orders, setOrders, values) => {
  fetch(`${apiUrl}/server/public/`,{
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      kitchen: 'updateQuantity',
      data: values,
    })
  })
  .then(response => {
    if (!response.ok)
    {
      return false;
    }
    return response.json();
  })
  .then(data => {
    const updatedQuantity = Object.entries(orders).reduce((acc, [oId, order]) => {
      const dishs = Object.entries(order).reduce((innerAcc, [dId, dish]) => {
        innerAcc[dId] = (dId !== values.dishId)
          ? dish
          : {
              comment: dish.comment ?? null,
              menu_name: dish.menu_name ?? null,
              qty: values.quantity,
              weight: dish.weight ?? null,
            };
        return innerAcc;
      }, {});
      acc[oId] = dishs;
      return acc;
    }, {});
    setOrders(updatedQuantity);
  })
  .catch(error => console.error(error));
}
  
export { getOrders, SuccessOrder, updateQuantity, cancelOrder};